import React, { useEffect, useState } from 'react'
import './UserGraph.scss';
import Graph from '../AdminConsole/Graph/Graph';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL, BASE_TEMPLATE } from '../../Constants';
import { isEmpty} from 'lodash';
import { handleAxiosResponse } from '../../Util';

export default function UserGraph() {

    const { id } = useParams();

    const [graphRecord, setGraphRecord] = useState({});
    const [error, setError] = useState('');

    const getGraphRecord = async () => {
        if(isEmpty(id)){
            return;
        }
        const record = handleAxiosResponse(await axios.get(`${API_URL}/graph/${id}`)).graph;
        if(isEmpty(record)){
            setError('No existe una gráfica con ese id');
            return;
        }
        if(isEmpty(record.template)){
            record.template = BASE_TEMPLATE;
        }
        setGraphRecord(record);
    }

    useEffect(()=>{
        getGraphRecord();
    },[]);

    return (
        <div className='user-graph'>
            { graphRecord && <Graph graphRecord={graphRecord} nodeDrag={true} nodeTextAnchorChangeEnabled={false} highlightMode={graphRecord.highlightMode} disableCategoryFilters="true"></Graph> }
            { error && <div className='error'>{error}</div> }
        </div>
    )
}
